export default {
    // 常规，全局 ， 弹框、 提示、警告等
    CommonObject:{
        greeting: "Welcome to HansVision!",
        shopgreeting:"Free Shipping on All Orders Over SGD 50! ",
        title: "HansVision",
        tipTitle: "Tip",
        warnTitle: "Alert",
        ok: "OK",
        sendEmail: "Send Email",
        back: "Back",
        exit: "Exit",
        cancel: "Cancel",
        close: "Close",
        confirm: "Confirm",
        retry:"Retry",
        submit:"Submit",
        success:"Success",

        fail: "Action Failed",

        delete: "Delete",
        remove: "Remove",
        save: "Save",
        eidt: "Edit",
        saving: "Saving in progress. Please wait",


        tomuch: "Too many attempts made! Try again 30 seconds later",
        tomuchone: "Too many attempts made! Try again 5 minutes later",

        // 没有数据
        emptyData: "There is nothing to display here",

        // 获取失败
        failtoget: "Error occurred during data acquisition",
        moduleDeveloping:'This module is under construction, please stay tuned...',

        companyAddress:'Address',
        serviceCenterAddress:'Service center address',
        newsLetter:'Join our newsletter',
        join:"Join"

    },

    // 通用登录
    LoginCommon:{
        unlogin: "Youre not logged in",
        unloginTip:  "Please log in first to continue",
        tologin: "Proceed to login",
        uncheckEmail: "The email address has not been verified",
        emailuncheckTip: "Your email address has not been verified. Please proceed to My Profile to verify your email",

        tokenExpire :"You are not logged in or Login session has expired. Please log in and try again!",

        
        orderQuery:'Order History'
    },

    // 登录
    LoginObject: {
        name: "Login",
        title: "Welcome",
        accountPlaceHolder: "Enter account / email address",
        passwordPlaceHolder:  "Enter password",
        accountRequire: "Account / Email address cannot be blank",
        passwordRequire: "Password cannot be blank",
        remember: "Remember me",
        forget: "Forgot password?",

        // 登录结果
        success:  "Login Successful",
        fail:  "Login Failed", 
        error: "Error occured during login",

        // 账号状态
        passwordLimit: "Password must have at least 6 digits",
        accountExpir: "Your account will",
        accountEnd: "expire on dd/mm/yyyy",
        accountExpired: "Your account has expired",
        accountExpirsubfix: "Please contact us to renew contract, or proceed to Rewards Redemption to redeem your reward points for the free trail period",

        // 重置密码
        resetTitle: "Reset password",
        emailPlaceHolder: "Please enter verification email",
        emailInvalidate: "Email address is invalid",
        nickNamePlaceHolder: "Please enter the nickname for your account",
        emailTips:"A link to change your password will be sent to your email. Please click the link to change your password",
        emailSend: "Email has been sent",
    },
    // 账号中心
    AccountCenterObject:{
        accountCenter: "My Profile",
        pointsRecord: "Records of Reward Points",
        exchangeRecord: "Records of Reward Redemption",
        matchRecord: "My Games",
        orderRecord: "My Orders",
        logout: "Logout",
        logoutTip:  "Are you sure you want to log out?",

        // 个人中心
        changeAvtar: "Change Avatar",
        infoBand: "Information Link",
        email: "Email address",
        points: "Reward points",
        changeEmail: "Change email address",
        checkEmail: "Verify email address",
        changePassword: "Change password",
        infoTitle: "Profile Info",

        userName:  "Name",
        sex:  "Gender",
        sexMale: "Male",
        sexFemale: "Female",
        phone: "Phone",
        school: "School",
        grade: "Standard",
        gradeHolder: "Please select Standard",
        eidt: "Edit",
        save: "Save",

        changeEmailTip: "We will send a verification email to the following email address. Click the link in the email address to verify",
        sendEmail: "Send verification email",

        sameAsBefore: "Same as current email address",

        phoneInput:  "Please enter a new phone number",
        phoneTitle: "Change phone number",
        invalidPhone: "Phone number is invalid",

        sendFirst: "Please send verification email request first",
        checkEmailContent:  "Please check your mailbox and perform email verification in accordance to the email message",

        imageTypeCheck: "Upload image can only be in JPG, JPEG or PNG format",
        imageLimit: "The image size cannot be greater than 2M",

        checking: "In the process of validating",
        checkSuccess: "Validation Successful",
        checkFail:"Validation Failed",

        changePasswordbofore:  "Link an email address to your account before password can be changed",
        willSendEmail:"A verification email will be sent to the following email address. Please perform verification in accordance to the email message",
    },

    // 积分记录
    PointRecordObject:{
        name: "Records of Reward Points",
        type: "Type",
        score: "Reward points",
        index: "Index",
        createTime: "Date",

        typegame: "Typing Game",
        dicGame: "Dictionary Game",

    },


    // 首页
    HomeObject:{
        name: "Home",
        hot: "Popular activities",
        myscore:  "My scores",
        more: "More",
        niceShop:'Shop Now'
    },
    
    FreetrialObject:{
        name: 'JoyReader Free Trial',

    },

    // 打字比赛
    TypingObject:{
        name: "Typing Game",
        practice: "Typing Practice",
        

    },
    // 游戏中心
    GameCenterObject:{
        name:'Game Center',
        gamePlane:'飞机大战',
        gameRace:'龟兔赛跑',
        gameBee:'蜜蜂采蜜',
    },
    // 打字游戏、 词典游戏  公共的
    GameObject:{
        instatistics:  "Calculating the score now. Please check later",
        signSuccess: "Registration Successful. Waiting for the game to start",
        signFail: "Registration Failed",
        finish: "The game has ended",
        seeinaccount:  'Check for details in "My Profile" -> "My Games"',
        signNow:  "Register now",
        noSign: "You have not register for the game yet",
        unlock: "Unlock",
        unlockfail: "Unlocking Failed",
        unlocksuccess: "Unlocking Successful",
        unlockenough: "Insufficient reward points for unlocking",
        notunlock: "Exercise is not unlocked",
        needPoints: "Reward points required for unlocking of Exercise",
        unlockPoints: "Reward points",

        // 练习进行时：
        overView: "Statistics",
        wordLabel: "Word count",
        levelLabel: "Level",
        correctLabel:  "Correct answer",
        errorLabel: "Wrong answer",
        speedLabel: "Speed",
        speedUnit: "word/minute",
        leftLabel:"Remaining",
        costTimeLabel:"Time used",
        minutes: "minutes",

        placeHodler: "Please enter contents",
        tipText: "Help me",
        hideTip: "Exit Help",
        finishText: "Exit",
        over:"Completed",
        submitText: "Submit",

        levelEasy: "Elementary",
        levelNormal: "Intermediate",
        levelHard: "Advance",

        dataLost: "Answers will not be saved",
        timeCountingdown: "Exam time is up. Answer sheet will be submitted automatically!",

        commitMulti: "Already submitted. Please do not resubmit",
        commitError: "Submission Failed",
        commitSuccess: "Submission Successful",

        timeCounting: "Countdown",
        gameTime:  "Game Time Limit",
        start: "Start now",

        scoreLabel: "Score",
        pointsLabel: "Accumulated points",

    },  
    // 词典比赛
    DictionaryObject:{
        name: "Dictionary Game",
        practice:"Word Search Practice",

        enterYourAnswer: "Please enter your answer here",
        yourAnswer: "Your answer",
        correctAnswer: "Correct answer",
        analysis:"Analysis",
        next: "Next question",
        before:"Previous question",

        timeLeft:"Time left",
        timeCost: "Time used",
        submitPaper: "Submit",
        finish: "Completed",
        minutes:"minutes",
        score: "Score",
        points: "Accumulated points",

        //答案模式
        totalScore: "Total Score",
        unit: "marks",
        questions: "No. of questions",
        undo: "Undone",
        done: "Done",
        correct: "Correct answer",
        error: "Wrong answer",
        mcq: "Multiple choice question",
        cloze: "Fill in the blank question",
        level: "Difficulty level",




    },

    // 成绩排行
    RankingObject:{
        name: "My Result",
        noData: "No record of accumulated points yet",
        myself: "My ranking",
    },
    // 积分商城
    PointShopObject :{
        name: "Rewards Redemption",
        title: "Rewards Redemption",
        exchangedNum: "persons redeemed",
        exchangedPer: "has/have redeemed",
        exchange: "Redeem now",

        willCost:  "You are about to spend",
        pointCount:  "points to redeem ",

        fillinfo: "Please complete the following information to proceed further",
        consignee: "Recipient",
        phone: "Contact No.",
        email: "Email Address",
        address: "Recipient Address",
        loginPassword: "Login Password",

        consigneeRequire: "Recipient is compulsory",
        phoneRequire: "Contact No is compulsory",
        emailRequire: "Email address is compulsory",
        addressRequire: "Address is compulsory",
        loginPasswordRequire: "Login Password is compulsory",

        pointNoUnough: "Insufficient reward points. Reward redemption is not allowed",

        exchangeSuccess: 'Redemption Successful. Check for details in "My Profile" -> "Records of Reward Redemption"',

    },

    // 商城
    ShopObject:{
        name: "Shop",
        category:'PRODUCT CATEGORIES',
        settlement: "Payment",

        outofstock:'OUT OF STOCK',

        packing: "Packaging Contents",
        level: "Please select Level",
        quantity: "Quantity",
        weight:"Specification",
        dimensions: "Dimensions",
        addToCart: "Add To Cart",

        download:'Download',
        shoppingCart: "Shopping Cart",
        productImage: "Product Image",
        productName: "Product",
        price: "Unit Price",
        totalPrice: "Total Price",
        action: "Action",



        subtotal: "Total",
        submary: "Cart Total",
        placeOrder: "Proceed to Checkout",

        expire:  "Expired",
        soldout:  "Sold out",

        removeTip:  "Are you sure you want to remove this product from the cart?",
        invalidTip: "Shopping cart contains invalid or expired product. Please delete it first",

        //支付信息
        checkOut:  "Payment Details",
        shippingInfo: "Shipping Details",
        country: "Country/ Region",
        shippingMethod: "Shipping Method",
        shippAddress: "Mailing Address",
        postCode: "Postcode/ Zip",

        paymentInfo: "Billing Details",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email Address",
        phone: "Phone",

        shoppingInfo: "Shopping Details",

        shippingFee: "Shipping Fee",
        shippingFeeTip: "For order over",
        shippingFeeTipsub:"shipping fee is waived",
        topay: "Place Order",

        //付款信息
        countryRequire: "Please select Country/Region",
        addressRequire: "Please enter your Mailing Address",
        postcodeRequire: "Please enter your Postcode/Zip",
        firstNameRequire: "Please enter your First Name",
        lastNameRequire: "Please enter your Last Name",
        phoneRequire: "Please enter your Phone No.",

        emailRequire: "Please enter your Email Address",
        invalidEmail: "Email Address is invalid",

        paymentInfoRequire:  "Missing a required field under Billing Details",
        shippingInfoRequire:  "Missing a required field under Shipping Details",

        purchaseLimit: 'Purchase Limit',
        useCoupon:"Use Coupon",
        
        invalidCoupon:'Invalid Coupon Code',
        expirCoupon: 'The coupon has expired or use time is not up',
        usedCoupon:'The coupon has been used',
        couponTip:"Both the coupon and the discount price exist, lower price will be used to calculate the total price.",
        couponCheck: "Verify",
        couponChange:"Change",
        
        pleaseInput:"Please input Coupon Code",
        checkTip:"If the coupon is verified successfully, it does not mean that coupon is used.",
        fileName:'File Name',
        download:'Download',
        operation:'Operation',
        video:'Video'
    },

    OrderObject:{
        detail: "Orders Details",
        subTotal: "Total Cost",
        includingFee:  "Include Shipping fee",

        waitPay: "Proceed to Payment",
        paied: "Paid",
        ack: "Confirm Receipt",
        signed: "Received",

        originalPrice: "Original price",
        discount: "Discount price",

        signedTip:  "Are you sure you have received the product?",

        waitPaying: "Redirecting you to the payment page. Please wait.if not,please click ok to redirect.",

        waitingForPay: "Waiting for payment....",
        paySuccess: "Payment Successful",
        payFail: "Payment Failed",
        payCancel: "Payment Cancelled",
        payTimeout: "Payment Timeout",
        autoClose: "This page is closing automatically soon",

        // OrderItem
        orderId: "Order No",
        totalGoods: "items",
        orderTime: "Transaction time",
        detail: "Detail",

        itemWaitPay: "Payment pending",
        itemPaied: "Paid",
        itemAck: "Shipped",
        itemSigned: "Received",

        // 详情问候
        orderTitle:"Thank you for your order",
        orderdone:'Order Confirmation!',
        greet:"Hi",
        receiveYourOrder:"We've received your order",
        thank:"Thank you for placing your order.",
        sendYouEmail:"We will soon send you an email confirmation.",
        pleaseContactUs:"If you need any further assistance, please don't hesitate to contact us.",
        success:"Congratulations on placing your order",
        succsssubfix:"successfully.",
        
        payTime:"Pay Time",
        payMount:"Pay Amount",
        myPayTip:"Thank you for your order!",
        myPaySubs:"To complete the order:",
        myPayStep1:"1.Use Bank app and scan QR, or PayNow to UEN# 201625979C.",
        myPayStep2:"2.Enter your order ID as bank reference number.",
        myPayStep3:"3.Order confirmation will be sent by the next working day.",
        myPayStepOrderNum:"Order ID:"

    },

    // 兑换记录
    ExchangeObject:{
        name: "Records of Rewards Redemption",
        tabAll: "All",
        tabWaitShipping:"Products to be delivered",
        tabWaitSign:"Products pending receipt",

        received:"Confirm receipt",
        tabSign:"Completed",

        index: "Index",
        pruduct:"Products",
        addressInfo: "Delivery details",
        points: "Reward points",
        status: "Status",
        update:  "Update time",
    },

    MyGameObject:{
        name: "My Games",
        typingGame: "Typing Game",
        dictGame: "Dictionary Game",
        gameTime: "Date of Game",
        untitle: "Untitled",
        unknown: "Unknown",
        score:  "Score",
        detail: "Details",
        tostart: "Not started yet",
        signup: "Registered",
        gaming: "In progress",
        submary: "Calculating",

        gameOverTip: "The game has ended. You did not submit an answer",
        inGameTip: 'The current game is in progress. Click "Confirm", to start immediately',
        gameSubmaring: "Game score is being calculated. Please check later",
        gameNoStart : "The game has not started yet",

    },

    // 保修登记
    WarrantyObject:{
        name: "Warranty Registration",
        title:  "Online Product Registration",
        userName: "Name",
        email: "Email Address",
        phone: "Phone No.",
        purchaseDate: "Date of Purchase",
        purchaseProduct: "Product Purchased",
        purchasePlace: "Place of Purchase",
        serialCode: "Serial Code",
        datePlaceHolder: "Please select a date of purchase",
        nameRequire: "Please enter your name",
        emailRequire: "Please enter your email address",
        palceReuqire: "Please enter the place of purchase",
        productRequire: "Please select an option",
        codeRequire: "Please enter the serial code of product",
        requireTip:'Required fields.',
        productWarranty:'Check here to indicate that you have read and understand the ',
        warrantItems:'warranty terms',
        fail:'please read the warranty items first!'
    },
    HelpObject:{
        name:'Help',
        contactUs:'Contact Us',
        locateUs:'Locate Us',
        faq:'FAQ',
        contactDetail:'Contact Details',
        serviceCenter:'Service Centre',
        serviceSub:'A Genuine Technology',
        address:'Address ',
        pohne:'Contact ',
        workTime:'Operating Hours',
        week:'Monday - Saturday',
        weekday:'Monday - Friday'
    },

    // 关于我们
    AboutObject:{
        name: "About Us",
        part1: "Creative Knowledge Labs Pte Ltd started out from the Chinese Software Department of Creative Technology Pte Ltd in Singapore, specializing in the field of digital education for over 20 years.",
        part2: "The current Creative Knowledge Labs Headquarters is based in Beijing. Being the operation lead of Creative Knowledge Labs, they inherited the values such as ‘Improving Lives by Technology’ and years of research from Creative Technology. Having achieved breakthroughs in speech recognition technology, language processing, online language assessment models, interactive educational technology, the company owns over 80 patents and software copyrights.",
        part3: "Creative Knowledge Labs combines technology with publishing, innovates methods for the construction of digital resources, and continuously upgrades the form and development of digital teaching materials and digital reading products. By using technology in education, the company induces a new concept of education, and gradually improves on product solutions such as those for digital picture book reading.  It has established application models for digital textbooks and digital classrooms, and built up a wealth of experience and a matured model in the development and operation of online education platforms.",
        part4: "Creative Knowledge Labs Pte Ltd (Singapore) is responsible for promoting our products and solutions throughout Southeast Asia, cooperating with partners in the region, tailoring these products to suit local needs and gaining our customers’ trust and favour.",
    },

    PromotionObject:{
        tip:'Enter passcode to proceed',
        enterCode: "Please enter Code",
        wait: "Please wait",
        ok: "OK",
        noStart : "Event has not started yet",
        over:  "Event has ended",
        time: "Time of Event",
        beforeStart:  "No of days to Event start date:",
        beforeEnd: "No of days to Event end date:",
    },

    // 联系方式
    ContactObject: {

    }


}


// WEBPACK FOOTER //
// ./src/lang/en_v1.js